import React, { useState, useEffect } from 'react';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Card from "@mui/material/Card";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";
import DefaultCompany from "../../myfin_v2/assets/imgs/defaultCompany.png";


const SelectResponsibility = ({ unrestrictedAcessData, userPermissionData, onCheckBoxChange }) => {

    const [selectedCompany, setSelectedCompany] = useState(null);

    useEffect(() => {
        if (userPermissionData && userPermissionData.length > 0) {
            setSelectedCompany({ ...userPermissionData[0], index: 0 });
        }
    }, [userPermissionData]);

    return (
        <>
            <div className={adminPortalCss.companyResponsibilitiesContainer}>
                <div className={adminPortalCss.unrestrictedAccessCard}>
                    <span className={adminPortalCss.unrestrictedAccessText}> Access Grant</span>
                    {unrestrictedAcessData.map((data, idx) => (
                        <div key={idx} className={adminPortalCss.permissionCard} style={{marginTop:"10px"}}>
                            <span className={adminPortalCss.permissionTitle}>
                                {data.title}
                            </span>
                            <div className={adminPortalCss.permissionActions}>
                                <label>
                                    <input type="checkbox" 
                                        name="create"
                                        checked={data.permission.create} 
                                        onChange={(e) =>
                                            onCheckBoxChange(e.target, "unrestrictedAcess" ,idx)
                                        }
                                        className={adminPortalCss.customCheckbox}
                                    /> Create
                                </label>
                                <label>
                                    <input type="checkbox" 
                                        name="delete"
                                        checked={data.permission.delete} 
                                        onChange={(e) =>
                                            onCheckBoxChange(e.target, "unrestrictedAcess" ,idx)
                                        }
                                        className={adminPortalCss.customCheckbox}
                                    /> Delete
                                </label>
                                <label>
                                    <input type="checkbox" 
                                        name="share"
                                        checked={data.permission.share} 
                                        onChange={(e) =>
                                            onCheckBoxChange(e.target, "unrestrictedAcess" ,idx)
                                        }
                                        className={adminPortalCss.customCheckbox}
                                    /> Share
                                </label>
                                <label>
                                    <input type="checkbox" 
                                        name="all_access_granted"
                                        checked={data.permission.all_access_granted} 
                                        onChange={(e) =>
                                            onCheckBoxChange(e.target, "unrestrictedAcess" ,idx)
                                        }
                                        className={adminPortalCss.customCheckbox}
                                    /> All Access
                                </label>
                            </div>
                        </div> 
                    ))}
                </div>
                <div className={adminPortalCss.companyPermissionContainer}>
                    <div className={adminPortalCss.dFlexClm} style={{ gap:"10px",maxHeight:"310px",overflowX:"auto",width:"370px" }}>
                        {userPermissionData.map((company, idx) => (
                            <div key={idx} 
                                className={adminPortalCss.companyCard}
                                onClick={() => setSelectedCompany({ ...company, index: idx })}
                                style={{
                                    borderColor:
                                    selectedCompany?.company?._id === company.company._id
                                        ? "#3AB67D"
                                        : "#EAEEED",    
                                    background:
                                    selectedCompany?.company?._id === company.company._id
                                        ? "#F4FAF5"
                                        : "#F8F9F9",
                                    // boxShadow:
                                    // selectedCompany?.company?._id === company.company._id
                                    //     ?"0px 10px 30px 0px rgba(10, 50, 36, 0.14)"
                                    //     : "none",

                                }}
                                >
                            <img
                                className={adminPortalCss.companyImage}
                                src={ company.company.logo_url || DefaultCompany}
                                alt="company_img"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =  DefaultCompany;
                                }} 
                            />
                            <span className={adminPortalCss.companyName}>{company.company.company_name}</span>
                            </div>
                        ))}
                    </div>
                    <div className={adminPortalCss.permissionContainer}> 
                        <div className={adminPortalCss.permissionCardContainer}>
                            {selectedCompany ? (
                                selectedCompany.components.map((component, idx) => (
                                    <div key={idx} className={adminPortalCss.permissionCard}>
                                        <span className={adminPortalCss.permissionTitle}>
                                            {component.title}
                                        </span>
                                        <div className={adminPortalCss.permissionActions}>
                                            <label>
                                                <input type="checkbox" 
                                                    name="create"
                                                    checked={component.permission.create} 
                                                    onChange={(e) =>
                                                        onCheckBoxChange(e.target, selectedCompany.index, idx)
                                                    }
                                                    className={adminPortalCss.customCheckbox}
                                                /> Create
                                            </label>
                                            <label>
                                                <input type="checkbox" 
                                                    name="delete"
                                                    checked={component.permission.delete} 
                                                    onChange={(e) =>
                                                        onCheckBoxChange(e.target, selectedCompany.index, idx)
                                                    }
                                                    className={adminPortalCss.customCheckbox}
                                                /> Delete
                                            </label>
                                            <label>
                                                <input type="checkbox" 
                                                    name="share"
                                                    checked={component.permission.share} 
                                                    onChange={(e) =>
                                                        onCheckBoxChange(e.target, selectedCompany.index, idx)
                                                    }
                                                    className={adminPortalCss.customCheckbox}
                                                /> Share
                                            </label>
                                            <label>
                                                <input type="checkbox" 
                                                    name="all_access_granted"
                                                    checked={component.permission.all_access_granted} 
                                                    onChange={(e) =>
                                                        onCheckBoxChange(e.target, selectedCompany.index, idx)
                                                    }
                                                    className={adminPortalCss.customCheckbox}
                                                /> All Access
                                            </label>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>Select a company to view permissions</p>
                            )}
                        </div>
                    </div>
                </div>
            </div> 
        </>
    )
}

export default SelectResponsibility

// const SelectResponsibility = ({
//     company,
//     onChange
// }) => {
//     return (
//         <>
//             <Accordion>
//                 <AccordionSummary
//                     className="text-uppercase font-inter"
//                     expandIcon={
//                         <ExpandMoreIcon
//                             style={{
//                                 width: "25px",
//                                 height: "25px",
//                                 borderRadius: "48px",
//                                 backgroundColor: "#F8F8F8",
//                                 color: "#717171",
//                             }}
//                         />
//                     }
//                     aria-controls="panel1-content"
//                     id="panel1-header"
//                 >
//                     {Array.isArray(company) ? "Access Granted" : company.company.company_name}
//                 </AccordionSummary>
//                 <AccordionDetails>
//                     <div className="container w-75">
//                         <p className="mt-0 mb-0  font-size-12 custom-font-600 font-sans">
//                             Access to:
//                         </p>
//                         <Card
//                             className="mt-2"
//                             style={{
//                                 border: "1px solid #D6D6D6",
//                                 borderRadius: "10px",
//                             }}
//                         >
//                             <table>
//                                 <thead className='custom-bg-white-150'>
//                                     <tr>
//                                         <th
//                                             style={{
//                                                 borderTopLeftRadius: "10px",
//                                             }}
//                                             className="text-uppercase font-inter font-size-12 custom-font-600 text-left"
//                                         >
//                                             Data
//                                         </th>
//                                         <th className="text-uppercase font-inter font-size-12 custom-font-600">
//                                             Create
//                                         </th>
//                                         <th className="text-uppercase font-inter font-size-12 custom-font-600">
//                                             Delete
//                                         </th>
//                                         <th className="text-uppercase font-inter font-size-12 custom-font-600">
//                                             Share
//                                         </th>
//                                         <th
//                                             style={{ borderTopRightRadius: "10px" }}
//                                             className="text-uppercase font-inter font-size-12 custom-font-600"
//                                         >
//                                             All Access
//                                         </th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {
//                                         Array.isArray(company) ? 
//                                             company.length > 0 && company.map((component, index) => (
//                                                 <TableRowPermission 
//                                                     component={component}
//                                                     index={index}
//                                                     onChange={onChange}
//                                                 />
//                                             ))
//                                         : company.components.length > 0 && company.components.map((component, index) => (
//                                             <TableRowPermission 
//                                                 component={component}
//                                                 index={index}
//                                                 onChange={onChange}
//                                             />
//                                         ))
//                                     }
//                                 </tbody>
//                             </table>
//                         </Card>
//                     </div>
//                 </AccordionDetails>
//             </Accordion>
//         </>
//     )
// }

// export default SelectResponsibility

// const CheckBoxPermission = ({
//     index,
//     checked,
//     name,
//     onChange
// }) => {
//     return <input
//         type="checkbox"
//         style={{ width: "20px", height: "20px" }}
//         name={name}
//         checked={checked}
//         onChange={(event) => onChange(event.target, index)}
//     />
// }

// const TableRowPermission = ({
//     index,
//     component,
//     onChange
// }) => {
//     return <tr key={index}>
//         <td
//             className="text-left border-top-0 border-bottom-0 mt-0 mb-0 pl-2 font-size-16 custom-font-500 font-sans"
//         >
//             {component.title}
//         </td>
//         <td className="border-top-0 border-bottom-0">
//             <CheckBoxPermission
//                 index={index}
//                 checked={component.permission.create}
//                 name="create"
//                 onChange={onChange}
//             />
//         </td>
//         <td className="border-top-0 border-bottom-0">
//             <CheckBoxPermission
//                 index={index}
//                 checked={component.permission.delete}
//                 name="delete"
//                 onChange={onChange}
//             />
//         </td>
//         <td className="border-top-0 border-bottom-0">
//             <CheckBoxPermission
//                 index={index}
//                 checked={component.permission.share}
//                 name="share"
//                 onChange={onChange}
//             />
//         </td>
//         <td className={`border-top-0 border-bottom-0`}>
//             <CheckBoxPermission
//                 index={index}
//                 checked={component.permission.all_access_granted}
//                 name="all_access_granted"
//                 onChange={onChange}
//             />
//         </td>
//     </tr>
// }